import type { ProductPicker } from "@/hooks/menu/useProductPicker";

interface ProductPickerSelectProps {
  id: string;
  picker: ProductPicker;
  value: string;
  onChange: (productId: string) => void;
  emptyLabel: string;
}

/**
 * Catalogue dish picker: a server-side search box above the dish list, with
 * "Afficher plus de plats" for the next page (SFRESTO-166).
 */
const ProductPickerSelect = ({
  id,
  picker,
  value,
  onChange,
  emptyLabel,
}: ProductPickerSelectProps) => (
  <div className="space-y-2 mt-1">
    <input
      type="search"
      aria-label="Rechercher un plat"
      placeholder="Rechercher un plat..."
      value={picker.search}
      onChange={(e) => picker.setSearch(e.target.value)}
      className="block w-full px-3 py-2 border border-gray-200 rounded-sm bg-white text-sm focus:outline-secondary"
    />
    <select
      id={id}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="block w-full px-3 py-2.5 border border-gray-200 rounded-sm bg-white text-sm focus:outline-secondary"
    >
      <option value="">{emptyLabel}</option>
      {picker.options.map((product) => (
        <option key={product.id} value={product.id}>
          {product.title}
        </option>
      ))}
    </select>
    {!picker.isFetching && picker.search.trim() && picker.options.length === 0 && (
      <p className="text-xs text-muted-foreground">Aucun plat trouvé</p>
    )}
    {picker.hasMore && (
      <button
        type="button"
        onClick={picker.loadMore}
        disabled={picker.isFetching}
        className="text-xs font-medium text-primary hover:underline disabled:opacity-60"
      >
        Afficher plus de plats
      </button>
    )}
  </div>
);

export default ProductPickerSelect;
